"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var recommendation_service_1 = require("../../service/recommendation-service");
var report_model_helper_1 = require("./report-model-helper");
var Observable_1 = require("rxjs/Observable");
var ReportRecommendationsHelper = /** @class */ (function () {
    function ReportRecommendationsHelper(predictionService) {
        this.predictionService = predictionService;
    }
    ReportRecommendationsHelper_1 = ReportRecommendationsHelper;
    ReportRecommendationsHelper.prototype.getRowBranchRecommendations = function (datasetId, rowPathIds, columnIds, validKeys) {
        return this.predictionService.predictRow(datasetId, rowPathIds, columnIds)
            .map(function (value) { return Array.from(value.keys()).filter(function (key) { return validKeys.indexOf(key.id) !== -1; }); });
    };
    ReportRecommendationsHelper.prototype.getColumnBranchRecommendations = function (datasetId, reportTableView, validKeys) {
        var _this = this;
        var rowBranches = report_model_helper_1.ReportModelHelper.getRowBranches(reportTableView);
        var columnIds = report_model_helper_1.ReportModelHelper.collectColumnIds(reportTableView).join(',');
        var predictions = rowBranches.map(function (rowBranch) {
            var rowPathIds = report_model_helper_1.ReportModelHelper.getRowIdsAsString(rowBranch);
            return _this.predictionService.predictColumn(datasetId, rowPathIds, columnIds);
        });
        return Observable_1.Observable.combineLatest(predictions).map(function (categoryCoefficients) {
            return _this.mergeRecommendations(categoryCoefficients, validKeys);
        });
    };
    ReportRecommendationsHelper.prototype.mergeRecommendations = function (categoryCoefficients, validKeys) {
        var coefficients = new Map();
        categoryCoefficients.forEach(function (categoryCoefficient) {
            categoryCoefficient.forEach(function (value, key) {
                if (validKeys.indexOf(key.id) !== -1) {
                    coefficients.set(key, Math.max(value, (coefficients.get(key) || 0)));
                }
            });
        });
        return Array.from(coefficients.entries())
            .sort(function (a, b) { return b[1] - a[1]; })
            .map(function (value) { return value[0]; })
            .slice(0, ReportRecommendationsHelper_1.RECOMMENDATIONS_COUNT);
    };
    var ReportRecommendationsHelper_1;
    ReportRecommendationsHelper.RECOMMENDATIONS_COUNT = 4;
    ReportRecommendationsHelper = ReportRecommendationsHelper_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [recommendation_service_1.RecommendationService])
    ], ReportRecommendationsHelper);
    return ReportRecommendationsHelper;
}());
exports.ReportRecommendationsHelper = ReportRecommendationsHelper;
//# sourceMappingURL=report-recommendations-helper.js.map